import { gql } from '@apollo/client';

export const API_KEYS_QUERY = gql`
  query apiKeys($teamId: String) {
    apiKeys(teamId: $teamId) {
      apiKeys {
        _id
        username
        name
        accountId
        teamIds
        apiKey {
          status
          scopes
        }
        createdAt
        lastUpdatedAt
      }
      accessToken {
        key
        expired
      }
    }
  }
`;

export const RENEW_ACCESS_TOKEN = gql`
  mutation renewAccessToken($teamId: String) {
    renewAccessToken(teamId: $teamId) {
      key
      expired
    }
  }
`;

export const API_KEY_TOKEN_QUERY = gql`
  query apiKeyToken($teamId: String, $apiKeyId: String!) {
    apiKeyToken(teamId: $teamId, apiKeyId: $apiKeyId)
  }
`;

export const CREATE_API_KEY = gql`
  mutation createApiKey($teamId: String, $payload: CreateApiKeyInput!) {
    createApiKey(teamId: $teamId, payload: $payload) {
      _id
      accessToken
    }
  }
`;

export const UPDATE_API_KEY = gql`
  mutation updateApiKey($teamId: String, $payload: UpdateApiKeyInput!) {
    updateApiKey(teamId: $teamId, payload: $payload) {
      _id
      name
      apiKey {
        status
        scopes
      }
      createdAt
    }
  }
`;

export const REVOKE_API_KEY = gql`
  mutation revokeApiKey($teamId: String, $payload: RevokeApiKeyInput!) {
    revokeApiKey(teamId: $teamId, payload: $payload)
  }
`;

export const UN_REVOKE_API_KEY = gql`
  mutation unRevokeApiKey($teamId: String, $payload: RevokeApiKeyInput!) {
    unRevokeApiKey(teamId: $teamId, payload: $payload)
  }
`;

export const DELETE_API_KEY = gql`
  mutation deleteApiKey($teamId: String, $payload: RevokeApiKeyInput!) {
    deleteApiKey(teamId: $teamId, payload: $payload)
  }
`;
